module.exports = __webpack_public_path__ + "img/apache.10b57011.png";